import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SKIP_TYPES = new Set(['section_header', 'section', 'header']);

// Mismo criterio que el backend (monitoring_routes.monitorable_qids).
export const monitorableQids = (questionnaire, answers, notApplicable = false) => {
  if (notApplicable) return [];
  const out = [];
  const seen = new Set();
  for (const q of (questionnaire?.questions || [])) {
    const qid = q?.question_id;
    if (!qid || seen.has(qid) || SKIP_TYPES.has(q.type)) continue;
    const text = q.text_es || q.text_en || q.text || '';
    if (typeof text === 'string' && text.trim().startsWith('##')) continue;
    const c = q.condition;
    if (c?.question_id && (answers || {})[c.question_id] !== c.equals) continue;
    seen.add(qid);
    out.push(qid);
  }
  return out;
};

const base = (studyId, volId) => `${API_URL}/api/studies/${studyId}/volunteers/${volId}/visit-responses/monitoring`;

export const monitoringApi = {
  check: (studyId, volId, body) => axios.post(`${base(studyId, volId)}/check`, body, { withCredentials: true }),
  complete: (studyId, volId, body) => axios.post(`${base(studyId, volId)}/complete`, body, { withCredentials: true }),
  uncomplete: (studyId, volId, body) => axios.post(`${base(studyId, volId)}/uncomplete`, body, { withCredentials: true }),
};

export const isQueryOpen = (q) => q.status !== 'terminada';

export const QUERY_STATUS = {
  en_curso: { es: 'Abierta', en: 'Open', color: 'bg-amber-50 text-amber-700 border-amber-200' },
  respondida: { es: 'Respondida', en: 'Answered', color: 'bg-sky-50 text-sky-700 border-sky-200' },
  terminada: { es: 'Cerrada', en: 'Closed', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
};

// Queries ligadas a un cuestionario concreto (voluntario + visita + cuestionario + entry).
export const queriesForQuestionnaire = (queries, fillQ, entryIndex = 0) => (queries || []).filter(q =>
  q.questionnaire_id
  && q.questionnaire_id === fillQ?.questionnaire?.questionnaire_id
  && q.visit_id === fillQ?.visit?.visit_id
  && q.volunteer_id === fillQ?.vol?.volunteer_id
  && (q.entry_index || 0) === (entryIndex || 0));

// En los cuestionarios solo se muestra la fecha (la hora queda en auditoría).
export const fmtDateTime = (iso, lang) => (iso ? new Date(iso).toLocaleDateString(lang === 'es' ? 'es-ES' : 'en-GB') : '');
